import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../api/AuthContext";
import { useLoading } from "../api/LoadingContext";
import backendApi from "../api/backendApi";
import LoadingButton from "./LoadingButton";

const LoginForm = ({ onSwitch }) => {
  const { login } = useAuth();
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      setSubmitting(true);
      setLoading(true);
      const res = await backendApi.post("/auth/login", formData);
      await login(res.data.token);
      navigate("/");
    } catch (err) {
      setError("Login failed. Please check your credentials.");
    } finally {
      setSubmitting(false);
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center">
      <div className="relative w-full max-w-md p-10 text-center">
        <img
          src="/Khuddam-Logo-Word.svg"
          alt="Khuddam Logo"
          className="h-20 mb-6 mx-auto"
        />
        <h2 className="text-4xl font-bold text-center mb-1">Khuddam Chanda</h2>
        <p className="text-center text-gray-500 mb-6">
          Enter your email and password
        </p>

        {error && <div className="text-red-500 mb-3 text-sm">{error}</div>}

        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring"
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Enter your password"
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring"
            required
          />

          <div className="flex justify-between text-sm text-gray-600">
            <label>
              <input type="checkbox" className="mr-1" /> Remember me
            </label>
            <Link
              to="/forgot-password"
              className="cursor-pointer hover:underline"
            >
              Forgot Password?
            </Link>
          </div>

          <LoadingButton type="submit" loading={submitting} variant="dark">
            Sign In
          </LoadingButton>
        </form>
        <p className="text-center mt-4">
          Don’t have an account?{" "}
          <span
            onClick={onSwitch}
            className="underline text-indigo-800 cursor-pointer"
          >
            Sign Up
          </span>
        </p>
        <p className="text-sm absolute bottom-0 left-0 right-0">
          <Link to="/guide" className="text-gray-700 hover:underline">
            Read the Guide here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LoginForm;
